import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import PostSept11ServiceDescription from '../../../../components/FormDescriptions/PostSept11ServiceDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--post911-title'];
const INPUT_LABEL = content['service-info--post911-label'];
const ARIA_DESC_TEXT = content['service-info--post911-aria-label'];

const { gulfWarService } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    gulfWarService: yesNoUI({
      title: INPUT_LABEL,
      description: PostSept11ServiceDescription,
      headerAriaDescribedby: ARIA_DESC_TEXT,
    }),
  },
  schema: {
    type: 'object',
    properties: { gulfWarService },
  },
};
